import { HAZARD_LABELS } from "@/lib/results";
import { HAZARD_BASIS } from "@/lib/report-basis";
import { HAZARD_TYPES } from "@shared/scoring/types";

/**
 * Indicators and baselines come from HAZARD_BASIS — the same verified strings
 * the PDF's "Basis of preparation" prints, whose baseline periods were checked
 * against the loaded data on 2026-09-19.
 *
 * Deliberately no "source" column: the redesign lists dataset names (CHIRTS,
 * CHC-CMIP6, Aqueduct 4.0, LHASA 1.1) and an "IPCC AR6 / CMIP6 reference
 * models" header that this codebase does not record anywhere, so every value
 * would be hand-entered and unverifiable. Add the column once the sources are
 * recorded alongside the indicators in report-basis.ts.
 */
export function HazardIndicatorTable() {
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-left text-xs">
        <thead>
          <tr className="border-b border-border bg-background/60 text-xs font-bold uppercase tracking-[0.08em] text-muted-foreground">
            <th className="px-4 py-3">Hazard</th>
            <th className="px-4 py-3">Indicator</th>
            <th className="px-4 py-3">Baseline period</th>
          </tr>
        </thead>
        <tbody>
          {HAZARD_TYPES.map((hazard) => {
            const basis = HAZARD_BASIS[hazard];
            return (
              <tr key={hazard} className="border-t border-border/60">
                <td className="px-4 py-3 font-bold">{HAZARD_LABELS[hazard]}</td>
                <td className="px-4 py-3 text-muted-foreground">{basis.indicator}</td>
                <td className="px-4 py-3 text-muted-foreground">
                  {basis.baselinePeriod ?? <span className="text-muted-foreground/60">Not stated</span>}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
